import { Reveal, Chapter } from "@/components/portfolio/motion";

const PARAS = [
  "I've spent eight plus years doing go-to-market for gaming and consumer products, almost seven of those at Tentworks Interactive, where I now lead marketing as CMO and COO. I own the full path from a game's first trailer to its launch week: positioning, community, press, events, paid, and everything in between. Before that I worked in B2B marketing and product at Smart Energy Systems, which is where I first learned how to read a dashboard and actually act on it.",
  "The last two years I've picked up something new. I started using AI tools to build real software, not demos, and it changed how I think about marketing entirely. I've shipped a full website and backend ops tool for a client's music business, and booking and client management apps for a hair salon and an AI company, all without writing code the traditional way. I'm IIM certified in AI for marketing, and I use tools like Claude, Gamma, Canva AI, Lovable, and Emergent every week, not as a novelty but as how I actually get things done now.",
  "Outside of work I'm usually playing something. Basketball, soccer, pickleball, and golf keep me busy, and I follow the NBA, the EPL, and cricket closely. I grew up believing marketing and building were two different jobs done by two different people. I don't think that's true anymore, and this site is basically the proof.",
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="scroll-mt-20 max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28 border-t border-line"
  >
    <Chapter num="01 / About" label="About" testId="about-chapter" />
    <div className="max-w-3xl space-y-7">
      {PARAS.map((p, i) => (
        <Reveal key={i} delay={i * 0.05}>
          <p
            data-testid={`about-paragraph-${i}`}
            className="leading-relaxed text-ink-soft text-base sm:text-lg"
          >
            {p}
          </p>
        </Reveal>
      ))}
    </div>
  </section>
);
